/** @format */

import styled from "styled-components";
import { BaseColor } from "../../../theme/maps/Colors";
import { C } from "../../../theme/maps/StatiPresenze";

/**
 * Colori con significato fisso (tavola "Stati della cella" della bozza): dalla Fase 5 Presenze
 * sono in theme/maps/StatiPresenze.ts, comuni alle due viste. Qui restano esportati con lo stesso nome.
 */
export { C };

export const COLONNE = "236px repeat(7, minmax(120px, 1fr)) 184px";

export const Pagina = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: ${C.testo};
`;

export const Intestazione = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;

  h1 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 1.1;
    color: ${BaseColor};
  }
  .sottotitolo {
    margin-top: 4px;
    font-size: 14px;
    color: ${C.testoSecondario};
  }
  .azioni {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const BarraStrumenti = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;

  .riga {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
  .settimana {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .etichetta-settimana {
    min-width: 176px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
  }
  .filtro {
    min-width: 200px;
    flex: 0 1 260px;
  }
  .ricerca {
    flex: 1 1 220px;
    max-width: 320px;
  }
  .spazio {
    flex: 1;
  }
  .mostra {
    font-size: 13px;
    color: ${C.testoSecondario};
    margin-right: 4px;
  }
  .interruttore {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
  .conteggio {
    display: inline-block;
    min-width: 20px;
    margin-left: 6px;
    padding: 0 6px;
    border-radius: 9px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    background: #e3e5ef;
    color: #3a4160;
  }
  .conteggio.rosso {
    background: #fbe1e7;
    color: ${C.anomalia.testo};
  }
  .conteggio.ambra {
    background: #fdebc8;
    color: #6e4300;
  }
  .conteggio.blu {
    background: #e3e7f7;
    color: #2f3a78;
  }
  .ant-picker-cell-week {
    display: none !important;
  }
`;

export const Griglia = styled.div`
  position: relative;
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;
  overflow: auto;
  max-height: max(420px, calc(100vh - 330px));

  .contenuto {
    min-width: 1180px;
  }
  .riga {
    display: grid;
    grid-template-columns: ${COLONNE};
  }
  .riga.testata {
    position: sticky;
    top: 0;
    z-index: 5;
    background: #fff;
    border-bottom: 1px solid ${C.linea};
  }
  .col-nome {
    position: sticky;
    left: 0;
    z-index: 3;
    min-width: 0;
    background: #fff;
    border-right: 1px solid ${C.linea};
  }
  .col-totali {
    position: sticky;
    right: 0;
    z-index: 3;
    padding: 10px 12px;
    background: ${C.fondoTotali};
    border-left: 1px solid ${C.linea};
  }
  .testata .col-nome,
  .testata .col-totali {
    z-index: 6;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 12px 14px;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .testata .unita {
    font-size: 12px;
    font-weight: 500;
  }
  .giorno {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    padding: 10px 10px 9px;
    border-right: 1px solid ${C.lineaLeggera};
  }
  .giorno .settimanale {
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .giorno .numero {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.15;
  }
  .giorno .oggi {
    font-size: 12px;
    font-weight: 700;
    color: ${BaseColor};
  }
  .giorno.e-oggi {
    background: ${C.oggi};
    box-shadow: inset 0 -3px 0 ${BaseColor};
  }
  .giorno.e-oggi .numero {
    color: ${BaseColor};
  }
  .giorno .nota {
    display: block;
    margin-top: 4px;
    padding: 2px 7px;
    border-radius: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 600;
    background: #eef0f8;
    color: #2f3a78;
  }
  .giorno .nota.festa {
    background: ${C.festa.fondo};
    color: ${C.festa.testo};
  }
  .giorno .nota + .nota {
    margin-top: 3px;
  }
  .giorno .bloccato {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }

  .riga.gruppo,
  .riga.reparto {
    background: ${C.fondoGruppo};
    border-bottom: 1px solid ${C.linea};
  }
  .riga.gruppo .col-nome,
  .riga.reparto .col-nome,
  .riga.gruppo .col-totali,
  .riga.reparto .col-totali {
    background: ${C.fondoGruppo};
  }
  .riga.gruppo .col-nome,
  .riga.reparto .col-nome {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    padding: 10px 12px;
  }
  .riga.reparto .col-nome {
    padding-left: 34px;
  }
  .apri-gruppo {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: -4px;
    padding: 4px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    font: inherit;
    font-size: 15px;
    font-weight: 700;
    color: ${C.testo};
    text-align: left;
    cursor: pointer;
  }
  .riga.reparto .nome-reparto {
    font-size: 14px;
    font-weight: 700;
  }
  .apri-gruppo .freccia {
    color: ${C.testoSecondario};
    transition: transform 0.15s;
  }
  .apri-gruppo .freccia.aperta {
    transform: rotate(90deg);
  }
  .conta-persone {
    padding-left: 24px;
    font-size: 12px;
    color: ${C.testoSecondario};
  }
  .riga.reparto .conta-persone {
    padding-left: 0;
  }
  .centro-gruppo {
    grid-column: span 7;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
  }
  .segnale {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 26px;
    padding: 0 10px;
    border: 0;
    border-radius: 13px;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }
  .segnale.rosso {
    background: #fbe1e7;
    color: ${C.anomalia.testo};
  }
  .segnale.ambra {
    background: #fdebc8;
    color: #6e4300;
  }
  .vuoto {
    position: sticky;
    left: 0;
    max-width: 640px;
    padding: 28px 20px;
  }

  @media (prefers-reduced-motion: reduce) {
    .apri-gruppo .freccia {
      transition: none;
    }
  }
`;

export const RigaPersonaStile = styled.div`
  border-bottom: 1px solid ${C.lineaLeggera};

  &:hover .col-nome {
    background: #fafbfe;
  }
  .persona {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
    padding: 10px 12px 10px 14px;
  }
  .persona .alto {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  .avatar {
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    overflow: hidden;
    background: #e4e7f3;
    color: #3a4580;
    font-size: 11px;
    font-weight: 700;
  }
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .nome {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 700;
  }
  .contratto {
    padding-left: 34px;
    font-size: 12px;
    color: ${C.testoSecondario};
  }
  .contratto.cambio {
    font-weight: 700;
    color: #2f3a78;
  }
  .icona-piccola {
    flex-shrink: 0;
    display: inline-flex;
    color: ${C.testoSecondario};
  }

  .cella {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    min-height: 66px;
    padding: 6px;
    border-right: 1px solid ${C.lineaLeggera};
  }
  .cella.e-oggi {
    background: ${C.oggi};
  }
  .cella.non-prevista {
    background-color: #f6f7f9;
    background-image: repeating-linear-gradient(
      135deg,
      transparent 0 7px,
      rgba(110, 116, 140, 0.14) 7px 8px
    );
  }
  .cella.festiva {
    background: ${C.festa.fondo};
  }
  .etichetta-festa {
    font-size: 11.5px;
    font-weight: 700;
    color: ${C.festa.testo};
  }
  .segnalazioni-giorno {
    position: absolute;
    top: 4px;
    right: 4px;
    display: grid;
    place-items: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: ${C.anomalia.fondo};
    color: ${C.anomalia.testo};
    font-size: 11px;
    font-weight: 700;
  }

  .turno {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    min-width: 0;
    padding: 6px 8px;
    border: 1px solid;
    border-radius: 8px;
    font: inherit;
    text-align: left;
    cursor: pointer;
  }
  .turno:focus-visible,
  .aggiungi:focus-visible {
    outline: 2px solid ${BaseColor};
    outline-offset: 2px;
  }
  .turno .orario {
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    font-size: 13.5px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .turno .giorno-dopo {
    font-size: 11px;
    opacity: 0.8;
  }
  .turno .sotto {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 600;
  }
  .turno .dettagli {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    font-size: 11.5px;
    font-weight: 700;
  }
  .turno .dettagli span {
    display: inline-flex;
    align-items: center;
    gap: 3px;
  }
  .turno.da_svolgere {
    background: ${C.daSvolgere.fondo};
    border-color: ${C.daSvolgere.bordo};
    color: ${C.daSvolgere.testo};
  }
  .turno.da_svolgere:hover {
    border-color: ${C.daSvolgere.hover};
  }
  .turno.in_corso {
    background: ${C.inCorso.fondo};
    border-color: ${C.inCorso.bordo};
    color: ${C.inCorso.testo};
  }
  .turno.timbrato {
    background: ${C.timbrato.fondo};
    border-color: ${C.timbrato.bordo};
    color: ${C.timbrato.testo};
  }
  .turno.mancata_timbratura {
    background: ${C.anomalia.fondo};
    border-color: ${C.anomalia.bordo};
    color: ${C.anomalia.testo};
  }
  .turno.non_lavorativo {
    border-color: transparent;
    background: ${C.riposo.fondo};
    color: ${C.riposo.testo};
  }
  .turno.non_lavorativo .orario {
    font-size: 13px;
    font-weight: 600;
  }
  .turno.con-avviso {
    border-color: ${C.avviso.bordo};
  }
  .punto-vivo {
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${C.inCorso.punto};
  }
  .segno-avviso {
    position: absolute;
    top: -7px;
    right: -7px;
    display: grid;
    place-items: center;
    width: 19px;
    height: 19px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: ${C.avviso.segno};
    color: #3d2600;
    font-size: 11px;
    font-weight: 800;
  }

  .assenza {
    padding: 6px 8px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    color: #3d2a1c;
  }
  .assenza.in-attesa {
    border: 1px dashed currentColor;
    background: transparent !important;
    font-weight: 600;
  }
  .assenza.ore {
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
  }

  .aggiungi {
    display: grid;
    place-items: center;
    width: 100%;
    height: 24px;
    border: 1px dashed transparent;
    border-radius: 8px;
    background: transparent;
    color: ${BaseColor};
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.12s;
  }
  .aggiungi.vuota {
    flex: 1;
    min-height: 50px;
  }
  .cella:hover .aggiungi,
  .aggiungi:focus-visible {
    opacity: 1;
  }
  .aggiungi:hover {
    border-color: #b9c0e2;
    background: #f4f5fc;
  }
  @media (hover: none) {
    .aggiungi {
      opacity: 0.6;
    }
  }

  .totali {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
  }
`;

export const Totali = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;

  .numeri {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-variant-numeric: tabular-nums;
  }
  .numeri strong {
    font-size: 15px;
  }
  .numeri .di {
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .barra {
    height: 5px;
    overflow: hidden;
    border-radius: 3px;
    background: ${C.barra.traccia};
  }
  .barra span {
    display: block;
    height: 100%;
    border-radius: 3px;
  }
  .barra .in_linea {
    background: ${C.barra.inLinea};
  }
  .barra .sotto {
    background: ${C.barra.sotto};
  }
  .barra .oltre {
    background: ${C.barra.oltre};
  }
  .delta {
    font-size: 12px;
    font-weight: 700;
  }
  .delta.in_linea {
    color: ${C.inLinea};
  }
  .delta.sotto {
    color: ${C.sotto};
  }
  .delta.oltre {
    color: ${C.avviso.testo};
  }
  .nota {
    font-size: 11.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .avviso {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11.5px;
    font-weight: 700;
    color: ${C.avviso.testo};
  }
`;

export const Legenda = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 20px;
  font-size: 12.5px;
  font-weight: 600;
  color: #4a5170;

  span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  i {
    display: inline-block;
    width: 24px;
    height: 14px;
    border: 1px solid;
    border-radius: 4px;
  }
`;
